/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { Row, Col, Menu, Dropdown, Button, message, Skeleton } from "antd";
import { DownOutlined } from "@ant-design/icons";
import {
  NavigationMenuCard,
  IndeksKarakterGrafikCard,
  IndeksKarakterHorizontalCard,
} from "../../../components/ui";
import Layout from "../../../layouts/MocoLayout";
import oRest from "../../../apis/rest";

const API_URL = "webhook/dataquery/?qname=";

const Page = () => {
  const [data, setData] = useState([]);
  const [provinceMenu, setProvinceMenu] = useState("ACEH");
  const [nasionalData, setNasionalData] = useState(null);
  const [provinceData, setProvinceData] = useState(null);
  const [year, setYear] = useState(2020);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: datas } = await oRest.get(
          `${API_URL}kemenag_indeks_karakter_by_year&year=${year}`
        );

        setData(datas);
        setNasionalData(datas.filter((e) => e.provinsi === "NASIONAL")[0]);
        setProvinceData(datas.filter((e) => e.provinsi === provinceMenu)[0]);
      } catch (error) {
        console.log(error);
        message.error("Terjadi kesalahan");
      }
    };
    fetchData();
  }, [year]);

  useEffect(() => {
    const handleChangeData = () => {
      setProvinceData(data.filter((e) => e.provinsi === provinceMenu)[0]);
    };

    if (data) handleChangeData();
  }, [provinceMenu]);

  const toPascalCase = (params) => {
    return params.charAt(0).toUpperCase() + params.slice(1).toLowerCase();
  };

  const handleChangeYearMenu = (e) => {
    setYear(e.key);
  };

  const yearMenu = (
    <Menu>
      <Menu.Item onClick={handleChangeYearMenu} key="2019">
        2019
      </Menu.Item>
      <Menu.Item onClick={handleChangeYearMenu} key="2020">
        2020
      </Menu.Item>
      <Menu.Item onClick={handleChangeYearMenu} key="2021">
        2021
      </Menu.Item>
      <Menu.Item onClick={handleChangeYearMenu} key="2022">
        2022
      </Menu.Item>
    </Menu>
  );

  const handleChangeDimensionMenu = (e) => {
    setProvinceMenu(e.key);
  };

  const provinceDropdownMenu = (
    <Menu>
      {data
        ?.map((e) => e.provinsi)
        .sort((a, b) =>
          // eslint-disable-next-line no-nested-ternary
          a > b ? 1 : b > a ? -1 : 0
        )
        .map((e) => {
          return (
            <Menu.Item onClick={handleChangeDimensionMenu} key={e}>
              {toPascalCase(e)}
            </Menu.Item>
          );
        })}
    </Menu>
  );

  return (
    <Layout>
      <NavigationMenuCard
        menu={[
          { title: "Indeks Karakter", path: "/indeks-karakter-siswa/1" },
          { title: "Peta Sebaran", path: "/indeks-karakter-siswa/2" },
          { title: "Detail Data", path: "/indeks-karakter-siswa/3" },
        ]}
      />
      <Row
        justify="end"
        style={{
          marginTop: 24,
          marginBottom: 24,
        }}
      >
        <Dropdown overlay={yearMenu}>
          <Button
            size="large"
            shape="round"
            style={{
              backgroundColor: "#1B6FBA",
              color: "#fff",
            }}
          >
            Pilih tahun &nbsp;
            <DownOutlined />
          </Button>
        </Dropdown>

        <Dropdown
          overlay={provinceDropdownMenu}
          overlayStyle={{ height: 300, overflowY: "auto" }}
        >
          <Button
            size="large"
            shape="round"
            style={{
              backgroundColor: "#1B6FBA",
              color: "#fff",
            }}
          >
            Pilih Provinsi &nbsp;
            <DownOutlined />
          </Button>
        </Dropdown>
      </Row>
      <Skeleton loading={data.length === 0} className="skeleton">
        <Row gutter={[24, 24]}>
          <Col
            span={12}
            className="text-header"
            style={{ textAlign: "center" }}
          >
            {`Indeks Karakter Nasional Tahun ${year}`}
          </Col>
          <Col
            span={12}
            className="text-header"
            style={{ textAlign: "center" }}
          >
            {`Indeks Karakter Provinsi ${provinceMenu}`}
          </Col>
          <Col span={5}>
            <IndeksKarakterGrafikCard
              title="Indeks Karakter"
              info="Info Indeks Karakter Nasional"
              data={nasionalData?.indeks_karakter}
            />
          </Col>
          <Col span={7}>
            <div
              style={{
                padding: 12,
                backgroundColor: "#fff",
                borderRadius: 12,
                height: "100%",
              }}
            >
              <Row gutter={[24, 6]}>
                <Col span={24}>
                  <IndeksKarakterHorizontalCard
                    title="Dimensi Integritas"
                    data={nasionalData?.integritas}
                  />
                </Col>
                <Col span={24}>
                  <IndeksKarakterHorizontalCard
                    title="Dimensi Kemandirian"
                    data={nasionalData?.kemandirian}
                  />
                </Col>
                <Col span={24}>
                  <IndeksKarakterHorizontalCard
                    title="Dimensi Nasionalisme"
                    data={nasionalData?.nasionalisme}
                  />
                </Col>
                <Col span={24}>
                  <IndeksKarakterHorizontalCard
                    title="Dimensi Relijiusitas"
                    data={nasionalData?.relijiusitas}
                  />
                </Col>
                <Col span={24}>
                  <IndeksKarakterHorizontalCard
                    title="Dimensi Gotong Royong"
                    data={nasionalData?.gotong_royong}
                  />
                </Col>
              </Row>
            </div>
          </Col>
          <Col span={7}>
            <div
              style={{
                padding: 12,
                backgroundColor: "#fff",
                borderRadius: 12,
                height: "100%",
              }}
            >
              <Row gutter={[24, 6]}>
                <Col span={24}>
                  <IndeksKarakterHorizontalCard
                    title="Dimensi Integritas"
                    data={provinceData?.integritas}
                    icon={nasionalData?.integritas < provinceData?.integritas}
                  />
                </Col>
                <Col span={24}>
                  <IndeksKarakterHorizontalCard
                    title="Dimensi Kemandirian"
                    data={provinceData?.kemandirian}
                    icon={nasionalData?.kemandirian < provinceData?.kemandirian}
                  />
                </Col>
                <Col span={24}>
                  <IndeksKarakterHorizontalCard
                    title="Dimensi Nasionalisme"
                    data={provinceData?.nasionalisme}
                    icon={
                      nasionalData?.nasionalisme < provinceData?.nasionalisme
                    }
                  />
                </Col>
                <Col span={24}>
                  <IndeksKarakterHorizontalCard
                    title="Dimensi Relijiusitas"
                    data={provinceData?.relijiusitas}
                    icon={
                      nasionalData?.relijiusitas < provinceData?.relijiusitas
                    }
                  />
                </Col>
                <Col span={24}>
                  <IndeksKarakterHorizontalCard
                    title="Dimensi Gotong Royong"
                    data={provinceData?.gotong_royong}
                    icon={
                      nasionalData?.gotong_royong < provinceData?.gotong_royong
                    }
                  />
                </Col>
              </Row>
            </div>
          </Col>
          <Col span={5}>
            <IndeksKarakterGrafikCard
              title="Indeks Karakter"
              info="Info Indeks Karakter Nasional"
              data={provinceData?.indeks_karakter}
              icon={
                nasionalData?.indeks_karakter < provinceData?.indeks_karakter
              }
            />
          </Col>
        </Row>
      </Skeleton>
      <div
        style={{
          marginBottom: 32,
        }}
      />
    </Layout>
  );
};

export default Page;
